/**
 * @file desktopStopKeepingSentence.ts
 * @description What stopping keeping does, in one place. Consumers:
 * `DesktopKeepConfirmBody` on the artifact toolbar and `KeptArtifactStopConfirm`
 * in Settings › Files on my computer, which confirm the same operation from two
 * surfaces and must not describe it two ways.
 *
 * All three promises are what the agent does: `runUnpin` leaves the visible
 * folder untouched, stopping deletes the pin and nothing else, and keeping again
 * is a fresh pin. The noun is a `string` rather than a union because a Settings
 * row whose artifact path is unrecognized reads as "item". Both call sites import
 * this by file rather than through `desktopSync/index.ts`, which would pull antd
 * components into a module that renders nothing.
 */

export const desktopStopKeepingSentence = (artifactNoun: string): string =>
    `Syncretic File Sync stops sending updates for this ${artifactNoun}. The files already on `
    + `your computer stay where they are, nothing is removed from Syncretic, and you can keep `
    + `this ${artifactNoun} again at any time.`;
